export const styles = {
  card: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: "16px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    border: "1px solid #eee",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  sectionTitle: {
    margin: "0 0 16px 0",
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#333",
    display: "flex",
    alignItems: "center",
  },
  pdfGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
    gap: "12px",
  },
  pdfCard: {
    display: "flex",
    alignItems: "center",
    borderRadius: "8px",
    overflow: "hidden",
  },
  pdfIcon: {
    padding: "12px",
    backgroundColor: "#f0f0f0",
    color: "#007bff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.5rem",
    minWidth: "60px",
  },
  pdfDetails: {
    padding: "12px",
    flex: 1,
    minWidth: 0,
  },
  pdfTitle: {
    fontWeight: 500,
    fontSize: "0.9rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#333",
  },
  pdfListCard: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  pdfViewerContainer: {
    border: "1px solid #ddd",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#f9f9f9",
  },
  pdfHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px",
    backgroundColor: "#fff",
    borderBottom: "1px solid #eee",
  },
  closeButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: 500,
    padding: "4px 8px",
    borderRadius: "4px",
    transition: "all 0.2s ease",
  },
  downloadBtn: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 12px",
    borderRadius: "4px",
    textDecoration: "none",
    fontSize: "0.85rem",
    fontWeight: 500,
    transition: "all 0.2s ease",
    border: "none",
    cursor: "pointer",
  },
  downloadIconBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 12px",
    borderRadius: "4px",
    textDecoration: "none",
    fontSize: "1rem",
    transition: "all 0.2s ease",
    cursor: "pointer",
    border: "1px solid #ddd",
    backgroundColor: "#f5f5f5",
  },
  pdfDisplayContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
    padding: "20px",
    backgroundColor: "#f0f0f0",
    overflow: "auto",
  },
  loadingText: {
    color: "#666",
    fontSize: "0.9rem",
  },
  errorText: {
    color: "#d93025",
    fontSize: "0.9rem",
  },
  pdfControls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    padding: "12px 16px",
    backgroundColor: "#fff",
    borderTop: "1px solid #eee",
  },
  navButton: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    fontSize: "0.85rem",
    fontWeight: 500,
    transition: "all 0.2s ease",
  },
  pageInfo: {
    fontSize: "0.9rem",
    fontWeight: 500,
    color: "#666",
    minWidth: "120px",
    textAlign: "center",
  },
};
